/**
 * Node Modules
 */
import React from 'react'

/**
 * Application Modules
 */
import './style.css'
import Section from '../../../components/section'

/**
 * Component
 */
export default function KeyValue({ className, hed, dek, links, img, alt }) {
  console.log(links, !!links &&links.length > 0)
  return (
    <Section className={`charter-key-value ${className || ''}`}>
      <div className="charter-key-value__grid grid">
        <div
          className="column-start-1 column-end-6 column-end-5--t flex flex-center"
          style={{ textAlign: 'center' }}
        >
          <img src={img} alt={alt} className="charter-key-value__image" />
        </div>

        <div className="column-start-1 column-end-6 column-start-6--t column-end-11--t  column-end-11--d  flex flex-center">
          <div>
            <h2 className="charter-key-value__hed">
              {hed}
            </h2>
            <p className="charter-key-value__dek">
              {dek}
            </p>
            <div className="charter-key-value__anchor-group">
              {(!!links && links.length > 0) && links.map(link => (
                <a className="charter-key-value__anchor-item" key={link.href} href={link.href}>
                  {link.text}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}
